import * as types from "./mutation-type";
import { API_STATES } from "@/helpers";

const mutations = {
  [types.GET_MODULES_BEGIN](state) {
    state.modulesGetState = API_STATES.REQUEST_PENDING;
  },
  [types.GET_MODULES_SUCCESS](state, modules) {
    state.modulesGetError = null;
    state.modules = modules;
    state.modulesGetState = API_STATES.REQUEST_SUCCESS;
  },
  [types.GET_MODULES_ERROR](state, err) {
    state.modulesGetState = API_STATES.REQUEST_ERROR;
    state.modulesGetError = err;
  },

  [types.CREATE_MODULE_BEGIN](state) {
    state.moduleCreateState = API_STATES.REQUEST_PENDING
  },
  [types.CREATE_MODULE_SUCCESS](state, data) {
    state.module = data;
    state.moduleCreateError = null;
    state.moduleCreateState = API_STATES.REQUEST_SUCCESS
  },
  [types.CREATE_MODULE_ERROR](state, err) {
    state.moduleCreateState = API_STATES.REQUEST_ERROR;
    state.moduleCreateError = err;
  },

  [types.UPDATE_COMPANY_MODULE_BEGIN](state) {
    state.companyModuleUpdateState = API_STATES.REQUEST_PENDING
  },
  [types.UPDATE_COMPANY_MODULE_SUCCESS](state, data) {
    state.module = data;
    state.companyModuleUpdateError = null;
    state.companyModuleUpdateState = API_STATES.REQUEST_SUCCESS
  },
  [types.UPDATE_COMPANY_MODULE_ERROR](state, err) {
    state.companyModuleUpdateState = API_STATES.REQUEST_ERROR;
    state.companyModuleUpdateError = err;
  },

  [types.CREATE_STORE_MODULE_BEGIN](state) {
    state.moduleStoreCreateState = API_STATES.REQUEST_PENDING;
  },
  [types.CREATE_STORE_MODULE_SUCCESS](state) {
    state.moduleStoreCreateError = null;
    state.moduleStoreCreateState = API_STATES.REQUEST_SUCCESS;
  },
  [types.CREATE_STORE_MODULE_ERROR](state, err) {
    state.moduleStoreCreateState = API_STATES.REQUEST_ERROR;
    state.moduleStoreCreateError = err;
  },

  [types.DELETE_STORE_MODULE_BEGIN](state) {
    state.moduleStoreDeleteState = API_STATES.REQUEST_PENDING;
  },
  [types.DELETE_STORE_MODULE_SUCCESS](state) {
    state.moduleStoreDeleteError = null;
    state.moduleStoreDeleteState = API_STATES.REQUEST_SUCCESS;
  },
  [types.DELETE_STORE_MODULE_ERROR](state, err) {
    state.moduleStoreDeleteState = API_STATES.REQUEST_ERROR;
    state.moduleStoreDeleteError = err;
  }
};

export default mutations;